import { Controller } from "@hotwired/stimulus"

// Replica el useState + conditional render del campo extra
// "hear_about_us_other" cuando el usuario elige "Otro" en el select
// hearAboutUs de UserDetails.tsx.
export default class extends Controller {
  static targets = ["hearAboutUs", "otherWrap"]

  toggleOther() {
    const isOther = this.hearAboutUsTarget.value === "other"
    this.otherWrapTarget.classList.toggle("hidden", !isOther)
  }
}
